import React, { useEffect } from 'react'
import { setModal, selectModal } from "../../redux/modalSlice"
import { useDispatch, useSelector } from 'react-redux'
import { selectUser } from '../../redux/userSlice'
import { hasUserPermission } from '../../utils/permissionHelper'

export default function AllowACHPaymentsModal() {
    const dispatch = useDispatch();
    const modal = useSelector(selectModal);
    const customerId = modal.options?.customerId;
    const active = useSelector(selectUser)
    const activePermissions = active.spoofed_user.user_permission_options ? active.spoofed_user.user_permission_options : active.data.user_permission_options
    const canACH = hasUserPermission(activePermissions, 'quick_action_ach_revocation_update');

    useEffect(() => {
        if (modal.is_active && modal.type === 'allow_ach_payments_modal') {
            if (canACH) {
                dispatch(
                    setModal({
                        is_active: true,
                        type: 'ach_revocation_modal',
                        options: { customerId: customerId, successCallback: () => {}, hasAchRevoked: true, hasBkConfirmed: modal.options?.hasBkConfirmed, removeACHText: 'This loan has an ACH revocation, please remove this before adding an ACH payment.' }
                    })
                )
            }
        }
    }, [canACH, customerId, modal.type]);

    const handleClick = async () => {
        dispatch(setModal({ is_active: false }));
      };

    if (modal.is_active && modal.type === 'allow_ach_payments_modal') {
      return (
        <div className="modal is-active">
          <div className="modal-background"></div>
          <div className="modal-card column is-10-tablet is-5-fullhd is-12-mobile">
            <header className={`modal-card-head has-bg-${modal.options?.type} py-3`}>
              <p className="modal-card-title is-capitalized">
                ACH Revocation Active
              </p>
              <button className="delete" aria-label="close" onClick={handleClick}></button>
            </header>
            <section
              className="modal-card-body modal-card-body pt-1 pb-1"
              style={{ minHeight: "100px", maxHeight: "600px", overflow: 'hidden' }}
            >
                This loan has an ACH revocation, please contact your manager to remove this before adding an ACH payment.
            </section>
            <footer className="modal-card-foot is-justify-content-end py-1 pr-1">
                <div className="lox-form__buttons-wrapper has-text-right">
                <button type="button" className="button is-small has-background-grey has-text-white" onClick={handleClick}>
                    OK
                </button>
                </div>
            </footer>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
